import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';

const MainLayout = () => {
  return (
    <div className="min-vh-100 d-flex flex-column" style={{ backgroundColor: '#ffffff' }}>
      <Navbar />
      <main style={{ marginTop: '56px', flex: 1, padding: '1.5rem 2.5rem' }}>
        <div className="container-fluid py-2 px-0">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default MainLayout;
